<div class="flex h-full w-full flex-col items-center justify-center">
  <div *ngIf="(isAppSpinnerVisible$ | async) !== true" class="text-xl">
    Select File
  </div>
</div>
